import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Heading,
  VStack,
  useBreakpointValue,
} from '@chakra-ui/react';
import { MODAL_FOOTER_PB, MODAL_HEADER_PT, VIEWPORT_MIN_H } from '@/constants/mobileLayout';
import { RulesPageContent } from '@/views/RulesPage/RulesPageContent';

/** Onboarding / edit-list only; main nav uses `/rules` page. */
export function RulesModal(props: { isOpen: boolean; onClose: () => void; prompt?: boolean; onNext?: () => void }) {
  const modalMaxW = useBreakpointValue({
    base: '100%',
    md: '70vw',
  });
  const modalCentered = useBreakpointValue({ base: false, md: true });
  const scrollBehavior = useBreakpointValue<'inside' | 'outside'>({ base: 'inside', md: 'outside' }) ?? 'inside';
  const titleSize = useBreakpointValue({ base: 'xl', md: '2xl' });

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      scrollBehavior={scrollBehavior}
      isCentered={modalCentered}
      size={{ base: 'full', md: 'xl' }}
    >
      <ModalOverlay />
      <ModalContent
        maxW={modalMaxW}
        maxH={{ base: '100%', md: '92vh' }}
        minH={{ base: VIEWPORT_MIN_H, md: undefined }}
        my={{ base: 0, md: 'auto' }}
        borderRadius={{ base: 0, md: 'md' }}
        display='flex'
        flexDirection='column'
      >
        <ModalHeader pt={MODAL_HEADER_PT} flexShrink={0}>
          <VStack align='stretch'>
            <Heading fontSize={titleSize}>How To Play</Heading>
          </VStack>
        </ModalHeader>
        <ModalCloseButton zIndex={2} mt={2} mr={2} />
        <ModalBody
          pb={MODAL_FOOTER_PB}
          flex='1'
          minH={0}
          overflowY='auto'
        >
          <RulesPageContent
            prompt={props.prompt}
            onNext={props.onNext}
            embeddedInModal
            showTournamentSummary
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
